// �������� ��� ������ Chromium: ������������ ������������ ���������,
// �������� "::not(title, meta)" ��� ":not(a, b)" -> ":not(a):not(b)"
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined')
    return;

  const fixSelector = (sel: string | null | undefined): string | null | undefined => {
    if (!sel || typeof sel !== 'string') return sel;

    // ��������� ������� ��������� ::not( -> :not(
    let s = sel.replace(/::not\(/g, ':not(');

    // �������� :not(a, b) �� :not(a):not(b)
    s = s.replace(/:not\(\s*([^)]+?)\s*\)/g, (_match, inner) => {
      if (inner.indexOf(',') === -1) return `:not(${inner.trim()})`;
      return inner
        .split(',')
        .map((part: string) => `:not(${part.trim()})`)
        .join('');
    });

    return s;
  };

  const wrap = (obj: any, name: 'querySelector' | 'querySelectorAll') => {
    if (!obj || !obj[name]) return;
    const original = obj[name] as Function;
    obj[name] = function (selector: any) {
      try {
        return original.call(this, selector);
      } catch (e) {
        try {
          const fixed = fixSelector(selector);
          // ���� ���� �� ������� ������ � ��������� ������������ ������
          if (fixed === selector) throw e;
          return original.call(this, fixed);
        } catch {
          // ������� �������� ������ � ��������� �� �������� � ��������� �������
          throw e;
        }
      }
    };
  };

  try {
    wrap(Document.prototype, 'querySelector');
    wrap(Document.prototype, 'querySelectorAll');
    wrap(Element.prototype, 'querySelector');
    wrap(Element.prototype, 'querySelectorAll');
  } catch {
    // ������ �� ������, ���� ��������� �������������
  }
})();